import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteDetailCampusInfoComponent} from './website-detail-campus-info.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'
import {RouterModule} from '@angular/router'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {PipesModule} from '../../pipes/pipes.module'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule,
    NgbNavModule,
    RouterModule,
    PipesModule
  ],
  declarations: [WebsiteDetailCampusInfoComponent],
  exports: [
    WebsiteDetailCampusInfoComponent
  ],
  providers: []
})
export class WebsiteDetailCampusInfoModule {
}
